// В.2.i: Био-резервуар (liv_bio_rezervuar, epic, 0/0/8).
// Триггер «в начале своего хода»: -1 ХП себе, +1 ХП Герою.
// Посмертие: +5 ХП Герою.
//
// Реализация:
//   - Триггер через registerOnStartOfTurnTrigger.
//   - Самоистощение: НЕ через applyDamage (это не атака, броня и Иммунитет
//     обходятся). Прямое current.hp -= 1. max_hp не меняется.
//   - Если current.hp ≤ 0 → юнит «убит» вручную (current.hp=0, alive=false,
//     removeFromField, dispatchUnitDied). Посмертие +5 Герою сработает в
//     обработчике on_unit_died.
//   - Если current.hp > 0 после самоистощения → healUnit(hero, +1).
//   - Молчание Био-резервуара блокирует ВЕСЬ триггер (caркас).
//
// Посмертие:
//   - registerOnUnitDiedExtraHandler с фильтром по cardId.
//   - При смерти Био-резервуара (своего владельца) → healUnit(hero, 5).
//   - Cap по max_hp Героя гарантирует healUnit.
//   - Молчание блокирует Посмертие. Молчание уже снято при смерти, поэтому
//     проверяем накопленный silenceSources до remove (в нашем хуке
//     получаем payload, где card — мёртвый Био-резервуар; silenceSources
//     остаются на инстансе — стандартный паттерн).
//
// Синергия с Бессмертным:
//   - Пассивка Бессмертного из В.2.h-rebalance триггерится на смерть любого
//     союзного юнита (+base.hp умершего к Герою). При смерти Био-резервуара
//     суммарно: +8 (пассивка Бессмертного) + 5 (Посмертие Резервуара).
//   - Cap по max_hp Героя в healUnit отрезает излишек. Защита от двойного
//     срабатывания НЕ нужна — синергия намеренна.

import { registerOnStartOfTurnTrigger } from './start-of-turn-triggers.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { registerOnUnitDiedExtraHandler, dispatchUnitDied } from '../deus/hooks.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_bio_rezervuar';
const LABEL = 'Био-резервуар';
const SOURCE_TRIGGER = 'liv_bio_rezervuar_trigger';
const SOURCE_DEATHRATTLE = 'liv_bio_rezervuar_deathrattle';
const HERO_HEAL_TRIGGER = 1;
const HERO_HEAL_DEATHRATTLE = 5;

registerImplementedAbility(CARD_ID, 'trigger', 'deathrattle');

registerOnStartOfTurnTrigger(CARD_ID, (state, rezervuar, ownerIdx) => {
  if (!rezervuar || !rezervuar.isAlive()) return;
  const owner = state.players?.[ownerIdx];
  if (!owner) return;
  // Самоистощение: прямое current.hp -= 1 (не через applyDamage).
  const before = rezervuar.current?.hp ?? 0;
  const after = before - 1;
  if (rezervuar.current) rezervuar.current.hp = Math.max(0, after);
  state.log?.add(
    `🧬 ${LABEL} [${owner.name}]: -1 ХП себе (${before}→${rezervuar.current.hp})`
  );
  if (rezervuar.current.hp <= 0) {
    // Смерть от своего же триггера. +1 Герою НЕ срабатывает.
    rezervuar.alive = false;
    owner.removeFromField(rezervuar);
    state.log?.add(`✗ ${rezervuar.name_ru} [${owner.name}] истощился до 0`);
    dispatchUnitDied(state, {
      ownerIdx, card: rezervuar, killer: rezervuar, killerIdx: ownerIdx, killerWasCounter: false
    });
    return;
  }
  // +1 Герою (cap по max_hp в healUnit).
  if (owner.hero && owner.hero.hp > 0) {
    healUnit(state, owner.hero, HERO_HEAL_TRIGGER, { id: SOURCE_TRIGGER, name_ru: LABEL, type: 'unit' });
  }
});

// Посмертие: +5 ХП Герою.
registerOnUnitDiedExtraHandler((state, payload) => {
  if (!payload) return;
  const dead = payload.card;
  if (!dead || dead.id !== CARD_ID) return;
  const ownerIdx = payload.ownerIdx;
  if (ownerIdx == null) return;
  const owner = state.players?.[ownerIdx];
  if (!owner?.hero || owner.hero.hp <= 0) return;
  // Молчание блокирует Посмертие.
  if (dead.current?.silenced) return;
  if (dead.silenceSources && dead.silenceSources.size > 0) return;
  state.log?.add(`🧬 ${LABEL} [${owner.name}]: Посмертие → +${HERO_HEAL_DEATHRATTLE} ХП Герою`);
  healUnit(state, owner.hero, HERO_HEAL_DEATHRATTLE,
    { id: SOURCE_DEATHRATTLE, name_ru: LABEL, type: 'unit' });
});
